import { RegionsAreasAggsType } from '@core/Entities/Location/RegionArea.entity';

import { RegionAreaAtom } from '@search/Atoms/RegionAtom.entity';

export const aggregationsToRegionsAreas = (
  areasAggs: RegionsAreasAggsType,
  regionsAggs: RegionsAreasAggsType,
) => {
  const regions: RegionAreaAtom[] = [];
  const areas: RegionAreaAtom[] = [];

  Object.keys(regionsAggs).forEach(regionKey => {
    const regionObj = regionsAggs[regionKey];

    regions.push({
      key: regionObj.id,
      displayName: regionObj.shortName,
      region: regionObj.id,
      location: {
        lat: regionObj.position?.lat ?? Number(regionObj.lat),
        lon: regionObj.position?.lon ?? Number(regionObj.lon),
      },
      postcode: regionObj.postcode,
      regionCode: regionObj.regionCode,
    });
  });

  Object.keys(areasAggs).forEach(areaKey => {
    const areaObj = areasAggs[areaKey];

    const areasFromRegion = {
      key: areaObj.areaCode ? areaObj.areaCode : areaObj.area,
      displayName: areaObj.shortName,
      region: areaObj.region,
      location: {
        lat: areaObj.position?.lat ?? Number(areaObj.lat),
        lon: areaObj.position?.lon ?? Number(areaObj.lon),
      },
      postcode: areaObj.postcode,
    } as RegionAreaAtom;

    areas.push(areasFromRegion);
  });

  return { regions, areas };
};
